/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
const Notfonud = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.Tawk_API && window.Tawk_API.toggle) {
        window.Tawk_API.toggle();
      }
    }, 4000);

    // Cleanup the timeout on unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* saved from url=(0051)https://getbootstrap.com/docs/4.0/examples/pricing/ */}
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {/* Meta Title */}
      <title>
        Norton Antivirus Activation &amp; Support | Redeem Product Key &amp;
        Contact Support
      </title>
      {/* Meta Description */}
      <meta
        name="description"
        content="Redeem your Norton Antivirus product key and activate your protection today! Need help? Our support team is available to assist with any issues or questions you may have."
      />
      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="Norton Antivirus, redeem product key, activate Norton, Norton support, antivirus activation, product key support, contact Norton support, Norton customer service"
      />
      {/* Meta Robots */}
      <meta name="robots" content="index, follow" />
      {/* Open Graph Meta Tags (for social media sharing) */}
      <meta
        property="og:title"
        content="Norton Antivirus - Redeem & Activate Product Key"
      />
      <meta
        property="og:description"
        content="Easily redeem and activate your Norton Antivirus product key. Our support team is here to assist with any activation issues or technical inquiries."
      />
      <meta property="og:image" content="" />
      <meta property="og:url" content="www.pcscancare.com" />
      <meta property="og:type" content="website" />
      {/* Twitter Card Meta Tags (for Twitter sharing) */}
      <meta
        name="twitter:title"
        content="Norton Antivirus - Activate Your Product Key & Get Support"
      />
      <meta
        name="twitter:description"
        content="Redeem your Norton Antivirus product key, activate your protection, and reach out to our support team for any help or troubleshooting needs."
      />
      <meta name="twitter:image" content="" />
      <meta name="twitter:card" content="summary_large_image" />
      {/* Canonical Link */}
      <link rel="canonical" href="www.pcscancare.com" />
      <link rel="icon" href="./assets/img/nlok.ico" />

      <div className="header-section border-bottom box-shadow">
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 bg-white ">
            <h5 className="my-0 mr-md-auto font-weight-normal">
              <img src="/main-logo.svg" alt="main logo" />
            </h5>
            <nav className="my-2 my-md-0 mr-md-3">
              <a className="p-2 text-dark" href="privacy.html">
                Privacy Policy
              </a>
              <a className="p-2 text-dark" href="terms.html">
                Terms &amp; Conditions
              </a>
              <span className="p-2 text-dark">
                <strong>Contact US: +1 (805) 222-0570 </strong>
              </span>
            </nav>
          </div>
        </div>
      </div>
      <div
        className="main d-flex align-items-center justify-content-center"
        style={{ minHeight: "83vh" }}
      >
        <div style={{ width: "70%", margin: "0px auto" }}>
          <div>
            <div style={{ textAlign: "center" }}>
              <h2
                style={{
                  textAlign: "center",
                  color: "rgb(87, 87, 87)",
                  fontFamily: "Lato, sans-serif",
                  fontSize: 36,
                  fontWeight: 400,
                }}
              >
                Error{" "}
                <span className="err" style={{ color: "rgb(192, 24, 24)" }}>
                  {" "}
                  "0X00361P"
                </span>{" "}
                Unable to Setup Product
              </h2>
            </div>
          </div>
          <div>
            <div>
              <p
                style={{
                  textAlign: "center",
                  color: "rgb(54, 54, 54)",
                  fontFamily: "Lato, sans-serif",
                  fontSize: 22,
                  fontWeight: 400,
                  margin: "20px 0px 40px",
                }}
              >
                Your key is redeemed successfully but the setup cannot be
                started
              </p>
            </div>
          </div>
          <div>
            <div>
              <h2
                style={{
                  textAlign: "center",
                  color: "rgb(158, 59, 27)",
                  fontFamily: "Lato, sans-serif",
                  fontSize: 23,
                  fontWeight: 400,
                  margin: "40px 0px",
                }}
              >
                Do not try again or turn off your device. You might loose your
                product key.
              </h2>{" "}
            </div>
          </div>
          <div>
            <div style={{ textAlign: "center" }}>
              <p
                style={{
                  color: "rgb(54, 54, 54)",
                  fontFamily: "Lato, sans-serif",
                  fontSize: 22,
                  fontWeight: 400,
                }}
              >
                The Error occurs because of Home Network XML Core Services
                (XML). XML is a set of services that allow applications written
                in JScript, VBScript, or Microsoft Office development tools to
                build Windows-native XML-based applications.
              </p>
            </div>
          </div>
          <div className="col-12 mt-3">
            <div className="d-grid text-center">
              <button
                className="btn-primary"
                type="submit"
                style={{ fontSize: 32, marginTop: 30 }}
              >
                📞 Call us at: +1 (805) 222-0570
              </button>
            </div>
          </div>
        </div>
      </div>
      <footer className="py-4 border-top">
        <div className="container d-flex justify-content-between align-items-center">
          <p style={{ fontSize: 12 }}>
            Copyright © 2024 Gen Digital Inc. All rights reserved.
          </p>
          <img src="/main-logo.svg" alt="main form" />
        </div>
      </footer>
      {/* Bootstrap core JavaScript
    ================================================== */}
      {/* Placed at the end of the document so the pages load faster */}
      <grammarly-desktop-integration data-grammarly-shadow-root="true">
        <template shadowrootmode="open" />
      </grammarly-desktop-integration>
    </>
  );
};

export default Notfonud;
